export function Custom404() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#000000',
        padding: '1rem',
      }}
    >
      <div
        style={{
          maxWidth: '42rem',
          width: '100%',
          textAlign: 'center',
        }}
      >
        {/* 404 Large Number */}
        <div
          style={{
            fontSize: '10rem',
            fontWeight: '700',
            lineHeight: '1',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif',
            marginBottom: '1rem',
            letterSpacing: '-0.02em',
          }}
        >
          404
        </div>

        {/* Title */}
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: '600',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif',
            marginBottom: '1rem',
          }}
        >
          Page Not Found
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: '1.125rem',
            color: '#a0a0a0',
            fontFamily: 'Inter, sans-serif',
            lineHeight: '1.75',
            marginBottom: '2.5rem',
            maxWidth: '32rem',
            margin: '0 auto 2.5rem',
          }}
        >
          Sorry, we couldn't find the page you're looking for. The page might have been removed, had its name changed,
          or is temporarily unavailable.
        </p>

        {/* Primary Action */}
        <div style={{ marginBottom: '2rem' }}>
          <a
            href="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0.875rem 2rem',
              fontSize: '1rem',
              fontWeight: '500',
              color: '#ffffff',
              backgroundColor: 'var(--dualite-primary-start)',
              border: 'none',
              borderRadius: '0.5rem',
              fontFamily: 'Inter, sans-serif',
              textDecoration: 'none',
              transition: 'all 0.2s',
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.9';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Go Back Home
          </a>
        </div>

        {/* Divider */}
        <div
          style={{
            width: '100%',
            height: '1px',
            backgroundColor: '#2a2a2a',
            margin: '2.5rem 0',
          }}
        />

        {/* Helpful Links */}
        <div>
          <p
            style={{
              fontSize: '0.875rem',
              color: '#707070',
              fontFamily: 'Inter, sans-serif',
              marginBottom: '1rem',
            }}
          >
            Here are some helpful links instead:
          </p>
          <div
            style={{
              display: 'flex',
              gap: '2rem',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <a
              href="/"
              style={{
                fontSize: '0.9375rem',
                color: '#ffffff',
                fontFamily: 'Inter, sans-serif',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--dualite-primary-start)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#ffffff';
              }}
            >
              Home
            </a>
            <a
              href="/pricing"
              style={{
                fontSize: '0.9375rem',
                color: '#ffffff',
                fontFamily: 'Inter, sans-serif',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--dualite-primary-start)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#ffffff';
              }}
            >
              Pricing
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
